import { FC } from 'react';
import { Input, InputElementProps, InputProps } from '../../UI';
import { useTranslation } from 'react-i18next';
import { RealEstateFormValues } from '../types';
import { useFormContext } from 'react-hook-form';

type RealEstatePropertyNicknameInputProps = Pick<InputProps, 'className'> & { inputProps?: InputElementProps };

export const RealEstatePropertyNicknameInput: FC<RealEstatePropertyNicknameInputProps> = ({
  className,
  inputProps,
}) => {
  const { t: tForm } = useTranslation('form');
  const { register, formState } = useFormContext<RealEstateFormValues>();

  return (
    <Input
      className={className}
      {...register('nickname', { required: true })}
      status={formState.errors.nickname ? 'errored' : 'normal'}
      label={tForm('real-estate-property-nickname-input-label')}
      inputProps={{ placeholder: tForm('general-required-placeholder'), ...inputProps }}
    />
  );
};
